import React, { Component } from 'react';
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import {getCurrentUser, submitChangePassword, uploadFile} from "../util/ApiUtils";
import {withStyles} from "@material-ui/styles";
import {NotificationManager, NotificationContainer} from "react-notifications";
import {ACCESS_TOKEN, V1_API_URL_PREFIX} from "../Constants";
import { withRouter } from "react-router-dom";
import * as CommonUtils from "../util/CommonUtils";
import { t } from '../i18n';

const classes = (theme => ({

    paper: {
        width: "100%",
        marginTop: theme.spacing(1),
        flexDirection: 'column',
        alignItems: 'center',
    },
    root: {
        width: '100%',
        overflowX: 'auto',
    },
}));

class Profile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            message: null,
            currentUser: null,
            uploadCalled: false,
            errorPwd: '',
            password: '',
            confirmPassword: '',
            oldPassword: '',
        };
        this.getUserData = this.getUserData.bind(this);
        this.onImageUpload = this.onImageUpload.bind(this);
        this.fileUploadHandler = this.fileUploadHandler.bind(this);
        this.deleteProfilePic = this.deleteProfilePic.bind(this);
        this.onPasswordChange = this.onPasswordChange.bind(this);
        this.submitPasswordChange = this.submitPasswordChange.bind(this);
    }

    componentDidMount() {
        this.getUserData();
    }

    deleteProfilePic() {
        const headers = new Headers({
            'Content-Type': 'application/json',
        });

        if (localStorage.getItem(ACCESS_TOKEN)) {
            headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
        }

        const defaults = {headers: headers};
        let options = Object.assign({}, defaults, {
            url: V1_API_URL_PREFIX + "/user/deleteFile",
            method: 'DELETE'
        });

        fetch(options.url, options)
            .then(response => {
                    if (response.status !== 204) {
                        console.log("error deleting profile pic")
                    }
                    this.getUserData();
                }
            );
    }

    getUserData() {
        this.setState({
            isLoading: true
        });
        getCurrentUser()
            .then(response => {
                console.log('response', response);
                this.setState({
                    currentUser: response,
                    isLoading: false,
                    uploadCalled: false,
                });
            }).catch(error => {
                console.log('error', error);
            this.setState({
                isLoading: false,
                uploadCalled: false
            });
        });
    }
    onImageUpload(event) {
        console.log('event.target.files[0]', event.target.files[0]);
        this.setState({
            selectedFile: event.target.files[0],
        });
    }
    onPasswordChange({ target }) {
        this.setState({
            ...this.state, [target.name]: target.value
        }, () => {
            if (this.state.password && this.state.confirmPassword && this.state.password !== this.state.confirmPassword) {
                this.setState({
                    errorMsg: t('profile.errors.passwordMismatch'),
                })
            } else {
                this.setState({
                    errorMsg: "",
                })
            }
        });
    }

    submitPasswordChange() {
        if (!this.state.oldPassword) {
            this.setState({
                errorMsg: t('profile.errors.enterOldPassword'),
            })
        } else if (this.state.password && this.state.confirmPassword && this.state.password === this.state.confirmPassword) {
            submitChangePassword(this.state.oldPassword, this.state.password).then((response) => {
                console.log('response error', response);
                console.log('response[\'errorMsg\']', response['errorMsg']);
                if (response['errorMsg']) {
                    NotificationManager.warning(t('app.notifications.error'), response['errorMsg'], 5000);
                    this.setState({
                        errorMsg: response['errorMsg'],
                    })
                } else {
                    this.setState({
                        oldPassword: '',
                        password: '',
                        confirmPassword: '',
                    });
                    NotificationManager.success(t('app.notifications.success'), t('profile.messages.passwordSaved'), 5000);
                }
            }).catch(error => {
                console.log('error', error);
                NotificationManager.warning(t('app.notifications.error'), t('profile.errors.changePasswordFailed'), 5000);
            });
        } else {
            this.setState({
                errorMsg: t('profile.errors.invalidPassword'),
            })
        }
    }

    fileUploadHandler = () => {
        this.setState({
            uploadCalled: true,
        });
        console.log('this.state.selectedFile', this.state.selectedFile);
        if (this.state.selectedFile === undefined) {
            this.setState({
                uploadCalled: false,
            });
            NotificationManager.warning(t('app.notifications.error'), t('profile.errors.selectFile'), 5000);
        } else {
            let filename = this.state.selectedFile.name;
            console.log('filename', filename);
            let suffix = ".jpg";
            let suffix1 = ".JPG";
            let suffix2 = ".jpeg";
            let suffix3 = ".JPEG";
            let suffix4 = ".png";
            let suffix5 = ".PNG";
            let suffix6 = ".pdf";
            let suffix7 = ".PDF";
            if ((filename.indexOf(suffix, filename.length - suffix.length) === -1)
                && (filename.indexOf(suffix1, filename.length - suffix1.length) === -1)
                && (filename.indexOf(suffix2, filename.length - suffix2.length) === -1)
                && (filename.indexOf(suffix3, filename.length - suffix3.length) === -1)
                && (filename.indexOf(suffix4, filename.length - suffix3.length) === -1)
                && (filename.indexOf(suffix5, filename.length - suffix3.length) === -1)
                && (filename.indexOf(suffix6, filename.length - suffix3.length) === -1)
                && (filename.indexOf(suffix7, filename.length - suffix3.length) === -1)
            ) {
                this.setState({
                    uploadCalled: false,
                });
                NotificationManager.warning(t('app.notifications.error'), t('profile.errors.supportedFiles'), 5000);
            } else {
                const callback = (status, res) => {
                    console.log("fileUploadHandler status " + status);
                    console.log("fileUploadHandler result " + res);
                    NotificationManager.success(t('app.notifications.success'), t('profile.messages.logoUploaded'), 5000);
                    this.setState({
                        selectedFile: null,
                    });
                    this.getUserData();
                };
                uploadFile("/user/profilePictureUpload", null, this.state.selectedFile, callback);
            }
        }
    };

    render() {
        let { isLoading } = this.state;
        let { classes } = this.props;
        if (isLoading) {
            return null;
        }
        let { currentUser } = this.state;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        console.log('currentUser in profile', currentUser);
        return (<React.Fragment>
                        <div className="container">
                            <h3>{ t('profile.title') }</h3>
                            <div className={classes.paper}>
                                { (currentUser && currentUser.profilePicture) ?
                                    <div>
                                        <div className="col-md-6 pull-right">
                                            <Button
                                                type="submit"
                                                fullWidth
                                                variant="contained"
                                                color="primary"
                                                disabled={isAuditor || isViewer}
                                                onClick={() => this.deleteProfilePic()}
                                            >
                                                { t('profile.actions.removeLogo') }
                                            </Button>
                                        </div>
                                        <div className="col-md-6 pull-right">
                                            <img src={this.picBase64(currentUser.profilePicture)} width="100%"/>
                                        </div>
                                    </div>
                                :
                                    <div>
                                            <h4>{ t('profile.uploadPrompt') }</h4>
                                            <TextField
                                                variant="outlined"
                                                margin="normal"
                                                required
                                                fullWidth
                                                id="file"
                                                name="file"
                                                autoFocus
                                                disabled={isAuditor || isViewer}
                                                onChange={this.onImageUpload}
                                                type="file"
                                            />
                                            <Button
                                                type="submit"
                                                fullWidth
                                                variant="contained"
                                                color="primary"
                                                onClick={() => this.fileUploadHandler()}
                                                disabled={this.state.uploadCalled || isAuditor}
                                            >
                                                { t('profile.uploadFile') }
                                            </Button>
                                    </div>
                                }
                            </div>
                            <NotificationContainer/>
                        </div>
                        { !isAuditor && !isDemo && <div className="container">
                            <h3>{ t('profile.changePassword') }</h3>
                            <div className={classes.paper}>
                                <div className="inputDiv">
                                    <span style={{color: 'red'}}>{this.state.errorMsg}</span>
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        required
                                        fullWidth
                                        id="oldPassword"
                                        label={ t('profile.labels.oldPassword') }
                                        name="oldPassword"
                                        type="password"
                                        value={this.state.oldPassword}
                                        onChange={ this.onPasswordChange }
                                        autoComplete="off"
                                    />
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        required
                                        fullWidth
                                        id="password"
                                        label={ t('profile.labels.password') }
                                        name="password"
                                        type="password"
                                        value={this.state.password}
                                        onChange={ this.onPasswordChange }
                                        autoComplete="off"
                                    />
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        required
                                        fullWidth
                                        id="confirmPassword"
                                        label={ t('profile.labels.confirmPassword') }
                                        name="confirmPassword"
                                        value={this.state.confirmPassword}
                                        type="password"
                                        onChange={ this.onPasswordChange }
                                        autoComplete="off"
                                    />
                                </div>
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                    onClick={ this.submitPasswordChange }
                                >
                                    { t('profile.actions.resetPassword') }
                                </Button>
                            </div>
                        </div>}
            </React.Fragment>
        )
    }

    pngBase64(encoded) {
        return "data:image/png;base64," + encoded;
    }

    picBase64(encoded) {
        return "data:image/png;base64," + encoded;
    }

    pdfBase64(encoded) {
        return "data:application/pdf;base64," + encoded;
    }
}

export default withStyles(classes)(withRouter(Profile));
